var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetAndGreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    is: "meetAndGreet",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.6667C4 8.45752 5.79086 6.66666 8 6.66666H24C26.2091 6.66666 28 8.45752 28 10.6667V22.6667C28 24.8758 26.2091 26.6667 24 26.6667H8C5.79086 26.6667 4 24.8758 4 22.6667V10.6667ZM8 8.66666H24C25.1046 8.66666 26 9.56209 26 10.6667V22.6667C26 23.7712 25.1046 24.6667 24 24.6667H19V17.0667C19.6 16.8667 20.2 16.5667 20.7 16.1667C22.2 14.9667 22.9 13.2667 23 11.0667V10.6667H21V11.1667C21 12.6667 20.48 13.8067 19.48 14.6067C18.68 15.2067 18 15.6667 16 15.6667C14 15.6667 12.21 16.4767 11.11 17.3767C9.71 18.5767 9 20.1667 9 22.1667V22.6667H11V22.1667C11.01 20.6667 11.5 19.7667 12.4 19.0667C12.5 18.9667 12.7 18.8667 13 18.7667V24.6667H8C6.89543 24.6667 6 23.7712 6 22.6667V10.6667C6 9.56209 6.89543 8.66666 8 8.66666ZM14 12.6667C14 13.7667 14.9 14.6667 16 14.6667C17.1 14.6667 18 13.7667 18 12.6667C18 11.5667 17.1 10.6667 16 10.6667C14.9 10.6667 14 11.5667 14 12.6667Z",
    fill: "#0083A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetAndGreet);
export default __webpack_public_path__ + "static/media/meetAndGreet.3702bd9a.svg";
export { ForwardRef as ReactComponent };